import React from 'react';
import { Button, message } from 'antd';
import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';
import { ReactComponent as NewVersionSvg } from '@assets/icons/timeline/create.svg';

export function showNewAssetVersionToast(
  assetId: string,
  onGoToLatestVersion: () => void
) {
  message.info({
    key: `new-version-${assetId}`,
    content: (
      <div className="message-dark-modal-content">
        <div>
          <div className="message-dark-modal-text">New version detected</div>
          <div className="message-dark-modal-text">
            <Button
              type="primary"
              onClick={() => {
                message.destroy(`new-version-${assetId}`);
                onGoToLatestVersion();
              }}
            >
              Go to the latest version
            </Button>
          </div>
        </div>
        <CrossSvg
          onClick={() => message.destroy(`new-version-${assetId}`)}
          className="message-dark-modal-close-btn"
        />
      </div>
    ),
    duration: 10,
    className: 'message-dark-modal b-with-button',
    icon: <NewVersionSvg width={50} height={50} className="anticon" />
  });
}
